import React from 'react';
import { AlertTriangle } from 'lucide-react';

// Shown when a lead shares a phone number with another lead (set by backend number_conflicts).
export function NumberConflictBadge({ lead, compact = false }) {
  const c = lead?.number_conflict;
  if (!c) return null;
  const text = `Number ${c.number} is also on "${c.other_name}" (${c.other_owner || 'pool'}, ${(c.other_stage || '').replace(/_/g, ' ')}). Resolve with your team leader before closing.`;
  if (compact) {
    return (
      <span className="inline-flex items-center gap-1 rounded-md border border-rose-300 bg-rose-50 px-1.5 py-0.5 text-[10px] font-semibold text-rose-700" title={text} data-testid={`number-conflict-${lead.id}`}>
        <AlertTriangle className="h-3 w-3" />Number conflict
      </span>
    );
  }
  return (
    <div className="col-span-2 rounded-md border border-rose-300 bg-rose-50 p-3 text-xs text-rose-800 flex gap-2" data-testid="number-conflict-detail">
      <AlertTriangle className="h-4 w-4 shrink-0 mt-0.5" />
      <div><b>Number conflict — resolve before closing.</b> {text}</div>
    </div>
  );
}
